// extracted by mini-css-extract-plugin
export default {"scroll":"Dropdown_scroll__IulVx"};